module.exports = __webpack_public_path__ + "img/spinner-small.e422403c.gif";